import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEmailEdit = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 20'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M22.999,9.000 C22.447,9.000 21.999,8.552 21.999,8.000 L21.999,3.563 L12.659,11.752 C12.470,11.917 12.235,12.000 12.000,12.000 C11.764,12.000 11.529,11.917 11.340,11.752 L2.000,3.563 L2.000,15.000 C2.000,15.551 2.449,16.000 3.000,16.000 L12.000,16.000 C12.552,16.000 12.999,16.448 12.999,17.000 C12.999,17.552 12.552,18.000 12.000,18.000 L3.000,18.000 C1.346,18.000 -0.000,16.654 -0.000,15.000 L-0.000,3.000 C-0.000,1.346 1.346,-0.000 3.000,-0.000 L20.999,-0.000 C22.653,-0.000 23.999,1.346 23.999,3.000 L23.999,8.000 C23.999,8.552 23.551,9.000 22.999,9.000 ZM3.251,2.000 L12.000,9.670 L20.748,2.000 L3.251,2.000 ZM14.603,15.927 C14.621,15.867 14.645,15.812 14.674,15.756 C14.709,15.690 14.746,15.632 14.793,15.576 C14.812,15.554 14.819,15.527 14.840,15.506 L19.524,10.820 C19.535,10.809 19.550,10.806 19.561,10.795 C19.571,10.784 19.575,10.770 19.585,10.759 C20.073,10.270 20.722,9.999 21.413,9.999 L21.414,9.999 C22.105,9.999 22.754,10.269 23.242,10.759 C23.730,11.246 24.000,11.896 24.000,12.589 C23.999,13.279 23.729,13.927 23.239,14.413 C23.230,14.423 23.217,14.426 23.207,14.435 C23.195,14.448 23.192,14.464 23.179,14.477 L18.497,19.162 C18.470,19.189 18.435,19.199 18.406,19.222 C18.361,19.258 18.315,19.288 18.265,19.316 C18.196,19.354 18.128,19.383 18.054,19.403 C18.027,19.411 18.007,19.429 17.979,19.434 L15.192,19.982 C15.128,19.994 15.063,20.000 14.999,20.000 C14.737,20.000 14.482,19.897 14.292,19.707 C14.057,19.471 13.954,19.134 14.018,18.807 L14.565,16.018 C14.572,15.985 14.593,15.959 14.603,15.927 ZM17.301,17.529 L21.764,13.063 C21.775,13.052 21.789,13.049 21.800,13.039 C21.812,13.025 21.817,13.008 21.829,12.996 C21.939,12.887 21.999,12.741 22.000,12.586 C22.000,12.430 21.939,12.283 21.828,12.172 C21.715,12.060 21.570,11.999 21.414,11.999 C21.259,11.999 21.113,12.060 21.003,12.171 C20.991,12.183 20.974,12.187 20.962,12.198 C20.952,12.209 20.948,12.224 20.938,12.234 L16.468,16.706 L16.267,17.732 L17.301,17.529 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEmailEdit.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
